export default __webpack_public_path__ + "static/media/carta_seleciona_01.24c1f47e.mp3";